import { useAppConfig } from "../AppConfigProvider";
import { Linking, Platform } from "react-native";
import Sentry from "../utils/sentry";
import { getValidAccessToken } from "../utils/authRefresh";

const useFileFetch = () => {
  const appConfig = useAppConfig();
  const currentDomain = appConfig?.currentDomain || "";

  const fetchAndOpenFile = async (url: string, options: { disposition?: string } = {}) => {
    const fullUrl = url.startsWith("/") ? `https://${currentDomain}${url}` : url;

    if (Platform.OS === "web") {
      try {
        const token = await getValidAccessToken();
        if (!token) {
          throw new Error("Missing access token for file fetch");
        }
        const iframeName = `_download_${Date.now()}`;
        const iframe = document.createElement("iframe");
        iframe.name = iframeName;
        iframe.style.cssText = "display:none;width:0;height:0;border:none;";
        document.body.appendChild(iframe);

        const form = document.createElement("form");
        form.method = "POST";
        form.action = fullUrl;
        form.target = iframeName;

        const tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "token";
        tokenInput.value = token;
        form.appendChild(tokenInput);

        if (options.disposition) {
          const dispositionInput = document.createElement("input");
          dispositionInput.type = "hidden";
          dispositionInput.name = "disposition";
          dispositionInput.value = options.disposition;
          form.appendChild(dispositionInput);
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
          }
        }, 10000);
      } catch (err) {
        console.error("Failed to open URL:", err);
        Sentry.captureException(err);
      }
    } else {
      try {
        const token = await getValidAccessToken();
        if (!token) {
          throw new Error("Missing access token for file fetch");
        }
        const body = options.disposition
          ? `token=${encodeURIComponent(token)}&disposition=${encodeURIComponent(options.disposition)}`
          : `token=${encodeURIComponent(token)}`;
        const response = await fetch(fullUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body,
        });
        const finalUrl = response.url;
        Linking.openURL(finalUrl);
      } catch (err) {
        console.error("Failed to open URL:", err);
        Sentry.captureException(err);
      }
    }
  };

  return { fetchAndOpenFile };
};

export default useFileFetch;
